<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#0EA5E9" :throttle="loadingThrottle" :height="loadingHeight" :duration="loadingDuration" />
    <NuxtPage class="min-h-screen" />
    <Transition name="slide-left">
      <CookieConsentBanner v-if="!cookieStatusHasBeenUpdated && !cookiesEnabled" class="z-50" />
    </Transition>
  </NuxtLayout>
</template>

<script setup lang="ts">
import AOS from 'aos'
import 'aos/dist/aos.css'

const { cookiesEnabled, cookieStatusHasBeenUpdated } = useCookies()

const loadingThrottle = 200
const loadingHeight = 3
const loadingDuration = 3000

onMounted(() => {
  AOS.init({
    easing: 'ease',
    once: true,
    offset: 25,
    delay: 400,
    duration: 600
  })

  const { initialize: initialiseHotjar } = useHotjar()
  initialiseHotjar()
})
</script>
